import { atomWithReset } from "jotai/utils";

export type typeformAtom = {
  isShow: boolean;
};

export const typeformAtom = atomWithReset<typeformAtom>({
  isShow: false,
});

export type TypeformAtom = {
  articlePollTypeform: Record<string, TypeformLinkConfig>;
};

export type TypeformLinkConfig = {
  isEnable: boolean;
  tooltipLabel: string;
  typeformLink: string;
};

export const defaultTypeformAtom: TypeformAtom = {
  articlePollTypeform: {},
};

export const articlePollTypeformAtom = atomWithReset<TypeformAtom>({
  articlePollTypeform: {},
});
